import * as types from '@/store/types';
import axios from 'axios';

export default {
  async showNotifications({ commit }, {type, page} ){
    try {
      const { data } = await axios.get(`/api/web/user/notifications/${type}?page=${page}`);
      commit(types.LIST_NOTIFICATIONS, { notifications: data });
      return data;
    }catch(e){
      return null;
    }
  }
};
